import HttpRequest from './HttpRequest';

export const getYoutubes = async () => {
  try {
    const response = await HttpRequest.get('/youtubes');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
